import { Select, SelectContentMaxPriority, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { calcularTotalValor, formatarMoedaPlano, type LinhaComposicao } from "@/constants/planosCNPJ";
import type { MotivoFicaCancelada } from "@/hooks/useMotivosFicaCancelada";

export const MANTER_MOTIVO_ATUAL = "manter";

export function contarItens(linhas: LinhaComposicao[]): number {
  return linhas.reduce((total, l) => total + (l.tipo === "SERVICO" ? Math.max(1, Math.floor(Number(l.quantidade) || 1)) : 1), 0);
}

const rotulo = (linhas: LinhaComposicao[]) => {
  const n = contarItens(linhas);
  return `${n} ${n === 1 ? "item" : "itens"} · ${formatarMoedaPlano(calcularTotalValor(linhas))}`;
};

interface ResumoRecuperacaoParcialProps {
  volta: LinhaComposicao[];
  fica: LinhaComposicao[];
  motivos: MotivoFicaCancelada[];
  motivoId: string;
  onMotivoChange: (id: string) => void;
}

/** Recuperar parte do pedido (Douglas 23/10/2026): o que volta, o que fica e por quê. */
export function ResumoRecuperacaoParcial({ volta, fica, motivos, motivoId, onMotivoChange }: ResumoRecuperacaoParcialProps) {
  return (
    <div className="space-y-2.5">
      <div className="grid grid-cols-2 gap-2">
        <div className="rounded-lg bg-[#F7EEEF] px-3 py-2 dark:bg-[#2A1F1F]">
          <p className="text-[11px] text-[#7A2235] dark:text-[#C87484]">Volta para o pedido</p>
          <p className="text-sm font-bold tabular-nums text-[#5B0A0D] dark:text-[#C87484]">{rotulo(volta)}</p>
        </div>
        <div className="rounded-lg bg-[#F3EFEA] px-3 py-2 dark:bg-white/[0.04]">
          <p className="text-[11px] text-muted-foreground">Fica cancelado</p>
          <p className="text-sm font-bold tabular-nums text-muted-foreground">{fica.length > 0 ? rotulo(fica) : "nada"}</p>
        </div>
      </div>
      {fica.length > 0 && (
        <div className="space-y-1">
          <p className="text-[11px] text-muted-foreground">
            Motivo dos itens que ficam cancelados <span className="text-[#9D2530]">*</span>
          </p>
          <Select value={motivoId} onValueChange={onMotivoChange}>
            <SelectTrigger className="h-8 text-xs">
              <SelectValue placeholder="Escolha o motivo" />
            </SelectTrigger>
            <SelectContentMaxPriority>
              {motivos.map((m) => (
                <SelectItem key={m.id} value={m.id} className="text-xs">{m.titulo}</SelectItem>
              ))}
              <SelectItem value={MANTER_MOTIVO_ATUAL} className="text-xs">Manter o motivo de hoje</SelectItem>
            </SelectContentMaxPriority>
          </Select>
        </div>
      )}
    </div>
  );
}
